const initialState = {
  favoritos: [],
  idPedido: -1,
};

export default initialState;
